import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { fsClass } from '@/styles/typography';

interface PublicFooterProps {
  className?: string;
  children?: React.ReactNode;
}

/**
 * Cosmos trust strip for public pages: subtle ice top border,
 * SECURE PORTAL caption with shield icon, muted ice text.
 */
const PublicFooter: React.FC<PublicFooterProps> = ({ className = '', children }) => {
  const { t } = useTranslation();

  return (
    <footer
      className={`w-full border-t border-border-ice bg-space-top/80 backdrop-blur-md safe-area-bottom ${className}`}
    >
      {children || (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-center gap-2">
          <ShieldCheck className="w-4 h-4 flex-shrink-0 text-success" aria-hidden />
          <span className={`font-ui ${fsClass.base} font-semibold uppercase tracking-[0.2em] text-caption-muted`}>
            {t('authenticatedFooter.securePortal', 'Secure portal')}
          </span>
        </div>
      )}
    </footer>
  );
};

export default PublicFooter;
